import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgRotateRight = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.2773 4.51929C15.5772 4.43921 15.8853 4.617 15.9658 4.91675L16.5479 7.09058C16.6282 7.3906 16.4504 7.69862 16.1504 7.77905L13.9766 8.36206C13.6767 8.4421 13.3684 8.26351 13.2881 7.96362C13.2079 7.66375 13.3858 7.35567 13.6855 7.27515L14.5039 7.05542C14.1609 6.89039 13.7979 6.75345 13.416 6.65112C10.1153 5.76671 6.72254 7.72558 5.83789 11.0261C4.95345 14.3269 6.91218 17.7197 10.2129 18.6042C13.5137 19.4887 16.9066 17.5301 17.791 14.2292C17.9294 13.7125 17.9979 13.1943 18.0029 12.6843C18.0061 12.3737 18.2607 12.1246 18.5713 12.1277C18.8819 12.1308 19.131 12.3854 19.1279 12.696C19.1219 13.2996 19.041 13.9116 18.8779 14.5203C17.8327 18.4212 13.8228 20.7364 9.92188 19.6912C6.0209 18.6459 3.70571 14.6361 4.75098 10.7351C5.79634 6.83433 9.80618 4.51904 13.707 5.56421C14.2048 5.69757 14.676 5.88217 15.1191 6.1062L14.8789 5.20776C14.7988 4.90785 14.9774 4.59965 15.2773 4.51929Z"
            fill="#5F47F6"
        />
    </svg>
);

export const RotateRightIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgRotateRight}
        fontSize={fontSize}
    />
);
